module.exports = __webpack_public_path__ + "img/banner-5.a94a3110.png";